<template>
  <div class="footerbox">
    <!-- 立即报名 
    <div class="add">
      <div class="sign-title">
        <div style="font-weight: 700">我们的服务优势</div>
      </div><br>
      <div class="sign-word">
        <p>专业的医疗顾问 公司现有员工都具有良好的资历，并在国内外受过专业业务训练。公司还不断地吸引国内外专业人士的加入，把国外最先进的检验技术和产品介绍到国内，为国内检验界开辟一代新纪元专业的医疗顾问公司现有员工都具有良好的资历，并在国内外受过专业业务训练。公司还不断地吸引国内外专业人士的加入，把国外最先进的检验技术和产品介绍到国内，为国内检验界开辟一代新纪元…...</p>
      </div>
    </div> -->
    <!--  底部  -->
    <div class="bottom-box">
      <div class="banner">
        <img src="@/assets/other/dibu.jpg" style="width: 100%;height: 400px;" alt="" />
        <span class="banner1">联系我们</span>
        <span class="banner2">湖南旭麓新材料科技有限公司</span>
        <span class="banner3">联系人：胡女士</span>
        <span class="banner4">手机号码：13755163377（微信同号）</span>
        <span class="banner5">QQ：1763707622</span>
        <span class="banner6">公司地址：岳麓山大学科技城岳麓街道溁左路中南大学科技园研发总部1栋264房</span>
        <span class="banner7">旭麓</span>
        <img class="banner8" src="@/assets/other/erweima.png" style="width: 100px;height: 100px;" alt="" />
        <span class="banner9">扫描二维码</span>
      </div>
      <div class="beian">
          <span>版权所有：湖南旭麓新材料科技有限公司&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp备案号：</span>
         <a href="https://beian.miit.gov.cn/" target="_blank" style="color: white;">湘ICP备2022022042号-2</a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    show: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    goSign() {
      this.$router.push({
        path: "/Signup"
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.footerbox {
  margin-top: 30px;
  width: 100%;

  /*  .footer-about {
    width: 100%;
    height: 240px;
    background: url("../../assets/image/back.png") no-repeat;
    background-position: center;

    .title {
      padding: 20px 0;
      font-size: 20px;
      font-weight: bold;
    }

    .content {
      width: 62%;
      margin: 0 auto;
      text-align: left;
      text-indent: 2em;
      line-height: 25px;
    }
  }

  .add {
    width: 100%;
    height: 200px;
    // margin-bottom: 40px;
    background: url("../../assets/image/rightnow.png") no-repeat;
    background-position: center;
    background-size: cover;
    position: relative;

    .sign-title {
      cursor: pointer;
      position: absolute;
      right: 48%;
      top: 15px;
      width: 200px;
      height: 60px;
      border-radius: 5px;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 18px;
      color: #ffffff;
    }

    .sign-word {
      position: absolute;
      right: 50%;
      top: 85px;
      width: 600px;
      height: 60px;
      border-radius: 5px;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 14px;
      text-align: left;
      color: #ffffff;
    }
  }

  .bottom {
    .b-cont {
      width: 100%;
      display: flex;

      .cont {
        text-align: left;
        width: 25%;
        font-weight: bold;
        font-size: 18px;
        padding-bottom: 30px;
      }

      .img {
        display: flex;
        width: 100%;

        .imgbox {
          width: 25%;
        }
      }
    }

    .tel {
      width: 100%;
      margin-top: 20px;
      margin-left: 10px;

      .title {
        text-align: left;
        font-weight: bold;
        font-size: 18px;
        padding-bottom: 20px;
      }

      .box {
        width: 100%;
        display: flex;
        flex-wrap: wrap;

        .boxitem {
          width: 100%;

          .each {
            width: 100%;
            margin-bottom: 20px;

            .title {
              text-align: left;
              font-weight: bold;
              font-size: 18px;
            }

            .foorter {
              .user {
                width: 100%;
                display: flex;
                flex-wrap: wrap;

                div {
                  width: 33%;
                }
              }

              text-align: left;
              display: flex;

              div {
                width: 50%;
              }
            }

            .address {
              text-align: left;
              padding-top: 10px;
              display: flex;
              justify-content: space-between;
            }
          }
        }
      }
    }
  } */
}
.bottom-box {
  padding: 100px 0 0 0;
  // background-color: #f8f5f0;
  .banner{
    position: relative;
  }
  .banner1{
    font-size: 30px;
    top: 160px;
    left: 290px;
    color: white;
    position: absolute;
  }
  .banner2{
    font-size: 15px;
    top: 220px;
    left: 290px;
    color: white;
    position: absolute;
  }
  .banner3{
    font-size: 15px;
    top: 250px;
    left: 290px;
    color: white;
    position: absolute;
  }
  .banner4{
    font-size: 15px;
    top: 280px;
    left: 290px;
    color: white;
    position: absolute;
  }
  .banner5{
    font-size: 15px;
    top: 310px;
    left: 290px;
    color: white;
    position: absolute;
  }
  .banner6{
    font-size: 15px;
    top: 340px;
    left: 290px;
    color: white;
    position: absolute;
  }
  .banner7{
    font-size: 30px;
    top: 140px;
    right: 320px;
    color: white;
    position: absolute;
  }
  .banner8{
    font-size: 15px;
    top: 210px;
    right: 300px;
    color: white;
    position: absolute;
  }
  .banner9{
    font-size: 15px;
    top: 330px;
    right: 310px;
    color: white;
    position: absolute;
  }
  .beian {
    padding-top: 20px;
    height: 60px;
    text-align: center;
    font-size: 16px;
    white-space: nowrap;
    font-weight: normal;
    color: white;
    background-color: #141d26;
  }
  /* .stle-box {
    display: flex;
    font-weight: 700;
    padding-left: 10px;
    font-size: 18px;
    line-height: 50px;
    text-align: left;
  } */
}
/* .zhuban-logo {
  display: flex;
  align-content: center;
  .logo-img {
    margin-right: 10px;
  }
} */

/* .logo-img span {
  display: inline-block;
  font-size: 16px;
  margin-right: 18px;
  font-weight: normal;
}
.code {
  width: 140px;
  position: absolute;
  right: 5px;
  top: 60px;
}
.bottom {
  position: relative;
} */
</style>



// WEBPACK FOOTER //
// src/components/Footer/index.vue